import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import {
    ReqDeleteEorExpiredEmployeeData,
    ReqQuoteData,
    ReqRejectSalary,
    ReqUpdateEmployee,
    ReqUpdateEmployeeSalary,
    ResDeleteEorExpiredEmployee,
} from "../interfaces";
import api from "../../services/api";
import i18next from '../../lang/i18n';
import {showUserFeedback} from "../userFeedback/actions";
import {
    API_END_POINT_APPROVE_SALARY,
    API_END_POINT_COMPANY,
    API_END_POINT_EMPLOYEE,
    API_END_POINT_UPDATE,
    API_ENDPOINT_COMPLETE_REGISTRATION, API_ENDPOINT_EOR_COMPANY, API_ENDPOINT_EOR_PARTNER, API_ENDPOINT_MODIFY,
    API_ENDPOINT_REJECT_SALARY, API_ENDPOINT_REQUESTER, API_ENDPOINT_SALARY,
    API_ENDPOINT_TERMINATE_CONTRACT,
    APÌ_END_POINT_SEND_QUOTE
} from "../../utils/constants";

export const fetchEmployees = createAsyncThunk('employees', async () => {
    const response = await api.get('/');
    return response.data;
});

export const updateEmployee = createAsyncThunk('update_employee', async (data: ReqUpdateEmployee, thunkAPI) => {
    try{
        const response = await api.put(`${API_END_POINT_UPDATE}${API_END_POINT_EMPLOYEE}/${data.employeeId}${API_END_POINT_COMPANY}/${data.companyId}`, data)
        thunkAPI.dispatch(showUserFeedback({
            type: 'success',
            title: i18next.t('employee_successfully_update_title'),
            message: i18next.t('employee_successfully_update_message')
        }))
        return response.data;
    }catch(error: any){
        thunkAPI.dispatch(showUserFeedback({
            type: 'error',
            title: i18next.t('error_message_title'),
            message: error.response?.data?.message || i18next.t('error_updating_employees')
        }))
    }
});

export const sendQuote = createAsyncThunk(
    'send_employee_quote',
    async (data: ReqQuoteData, thunkAPI) => {
        try {
            const { companyId, employeeId, ...quoteData } = data;
            const response = await api.put(
                `${APÌ_END_POINT_SEND_QUOTE}${API_END_POINT_EMPLOYEE}/${employeeId}${API_END_POINT_COMPANY}/${companyId}`,
                quoteData
            );
            thunkAPI.dispatch(showUserFeedback({
                type: 'success',
                title: i18next.t('quote_sent_title'),
                message: i18next.t('quote_sent_subtitle')
            }));
            return response.data;
        } catch (error: any) {
            thunkAPI.dispatch(showUserFeedback({
                type: 'error',
                title: i18next.t('error_message_title'),
                message: error.response?.data?.message || i18next.t('error_sending_quote')
            }));
        }
    }
);


export const deleteExpiredEorEmployee = createAsyncThunk<ResDeleteEorExpiredEmployee, ReqDeleteEorExpiredEmployeeData>(
    'delete_expired_eor_employee',
    async ({ employeeId, companyId, employeeName, adminUser }, thunkAPI) => {
        try {
           const response = await api.delete(
                `${API_END_POINT_EMPLOYEE}/${employeeId}${API_END_POINT_COMPANY}/${companyId}/quote`,
                { data: { employeeName, adminUser } }
            );

            thunkAPI.dispatch(showUserFeedback({
                type: 'success',
                title: i18next.t('quote_canceled_title'),
                message: i18next.t('quote_canceled_description'),
            }));
            return response.data;
        } catch (error: any) {
            return thunkAPI.dispatch(showUserFeedback({
                type: 'error',
                title: i18next.t('error_message_title'),
                message: error.response?.data?.message || i18next.t('error_cancelling_quote')
            }));
        }
    }
);

export const approveSalaryUpdate = createAsyncThunk(
    'approve_salary_update',
    async ({employeeId, companyId}: {employeeId: string, companyId: string}, thunkAPI) => {
        try {
            const response = await api.put(
                `${API_END_POINT_APPROVE_SALARY}${API_END_POINT_EMPLOYEE}/${employeeId}${API_END_POINT_COMPANY}/${companyId}`
            );
            thunkAPI.dispatch(showUserFeedback({
                type: 'success',
                title: i18next.t('salary_approved_feedback_title'),
                message: i18next.t('salary_approved_feedback_message')
            }));
            return response.data;
        } catch (error: any) {
            thunkAPI.dispatch(showUserFeedback({
                type: 'error',
                title: i18next.t('error_message_title'),
                message: error.response?.data?.message || i18next.t('error_approving_salary')
            }));
        }
    }
);

export const rejectSalaryUpdate = createAsyncThunk(
    'reject_salary_update',
    async (data: ReqRejectSalary, thunkAPI) => {
        try {
            const { companyId, employeeId, ...reason } = data;
            const response = await api.put(
                `${API_ENDPOINT_REJECT_SALARY}${API_END_POINT_EMPLOYEE}/${employeeId}${API_END_POINT_COMPANY}/${companyId}`,
                reason
            );
            thunkAPI.dispatch(showUserFeedback({
                type: 'success',
                title: i18next.t('salary_rejected_feedback_title'),
                message: i18next.t('salary_rejected_feedback_message')
            }));
            return response.data;
        } catch (error: any) {
            thunkAPI.dispatch(showUserFeedback({
                type: 'error',
                title: i18next.t('error_message_title'),
                message: error.response?.data?.message || i18next.t('error_rejecting_salary')
            }));
        }
    }
);

export const completeRegistration = createAsyncThunk(
    'complete_registration',
    async (data: {employeeId: string, companyId: string, contract:string}, thunkAPI) => {
        try {

            const response = await api.put(
                `${API_ENDPOINT_COMPLETE_REGISTRATION}${API_END_POINT_EMPLOYEE}/${data.employeeId}${API_END_POINT_COMPANY}/${data.companyId}`,
                {contract: data.contract}
            );
            thunkAPI.dispatch(showUserFeedback({
                type: 'success',
                title: i18next.t('employee_successfully_registered_title'),
                message: i18next.t('employee_successfully_registered_message')
            }));
            return response.data;
        } catch (error: any) {
            thunkAPI.dispatch(showUserFeedback({
                type: 'error',
                title: i18next.t('error_message_title'),
                message: error.response?.data?.message || i18next.t('error_completing_registration')
            }));
        }
    }
);

export const terminateContract = createAsyncThunk(
    'terminate_contract',
    async (data: {employeeId: string, companyId: string, requester: string}, thunkAPI) => {
        const {employeeId, companyId, requester} = data;
        try {
            const response = await api.put(
                `${API_ENDPOINT_TERMINATE_CONTRACT}${API_END_POINT_EMPLOYEE}/${employeeId}${API_END_POINT_COMPANY}/${companyId}${API_ENDPOINT_REQUESTER}/${requester}`
            );
            thunkAPI.dispatch(showUserFeedback({
                type: 'success',
                title: i18next.t('contract_successfully_terminated_title'),
                message: i18next.t('contract_successfully_terminated_message')
            }));
            return response.data;
        } catch (error: any) {
            thunkAPI.dispatch(showUserFeedback({
                type: 'error',
                title: i18next.t('error_message_title'),
                message: error.response?.data?.message || i18next.t('error_terminating_contract')
            }));
        }
    }
);

export const editEorPartner = createAsyncThunk('edit_eor_partner', async (data: {employeeId: string, companyId: string, eor_partner: string}, thunkAPI) => {
    try{
       const response = await api.post(`${API_ENDPOINT_EOR_PARTNER}${API_END_POINT_EMPLOYEE}/${data.employeeId}${API_END_POINT_COMPANY}/${data.companyId}`, data)
        return response.data;
    }catch(error: any){
        throw error;
    }
});

export const editEorCompany = createAsyncThunk('edit_eor_partner', async (data: {employeeId: string, companyId: string, eor_company: string}, thunkAPI) => {
    try{
        const response = await api.post(`${API_ENDPOINT_EOR_COMPANY}${API_END_POINT_EMPLOYEE}/${data.employeeId}${API_END_POINT_COMPANY}/${data.companyId}`, data)
        return response.data;
    }catch(error: any){
        throw error;
    }
});

export const modifyEmployeeSalary = createAsyncThunk(
    'modify_salary',
    async (data: ReqUpdateEmployeeSalary, thunkAPI) => {
        const {employeeId, companyId, ...body} = data;
        try {
            const response = await api.put(
                `${API_END_POINT_EMPLOYEE}/${employeeId}${API_END_POINT_COMPANY}/${companyId}${API_ENDPOINT_SALARY}${API_ENDPOINT_MODIFY}`,
                body
            );
            thunkAPI.dispatch(showUserFeedback({
                type: 'success',
                title: i18next.t('employee_salary_successfully_modified_title'),
                message: i18next.t('employee_salary_successfully_modified_message')
            }));
            return response.data;
        } catch (error: any) {
            thunkAPI.dispatch(showUserFeedback({
                type: 'error',
                title: i18next.t('error_message_title'),
                message: error.response?.data?.message || i18next.t('employee_salary_modified_error_message')
            }));
        }
    }
);


export const resetEmployeesUpdateStatus = createAction('reset_employees_update_status');
